import { useMutation } from "react-query";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { ReferralApi } from "../../../services";
import { getUser } from "../../../utils";

export const useValidateReferralCode = (referralCode: string) => {
  const { ciam_token } = getUser();

  const requestVerifyCodeMutation = useMutation(
    MUTATION_KEYS.verifyReferralCode,
    ({ referralCode, ciam_token }: { referralCode: string; ciam_token: string }) =>
      ReferralApi.init().verifyCode(referralCode, ciam_token)
  );

  const handleCodeValidation = async () => {
    const validateCode = await requestVerifyCodeMutation.mutateAsync({ referralCode, ciam_token });
    return validateCode;
  };

  return {
    ...requestVerifyCodeMutation,
    handleCodeValidation,
  };
};
